import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

const UserSelectionModel = ({ show, onHide, onConfirm, title, message }) => {
  return (
    <React.Fragment>
      <Modal show={show} onHide={onHide} centered size="sm">
        <div className="modal-content">
          <div className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onHide}></div>
          <div className="modal-body text-center py-4">
            <h3>{title}</h3>
            <div className="text-muted">{message}</div>
          </div>
          <div className="modal-footer">
            <div className="w-100">
              <div className="row">
                <div className="col">
                  <Link onClick={onHide} className="btn w-100" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                </div>
                <div className="col">
                  <Link onClick={onConfirm} className="btn btn-danger w-100">
                    Confirm
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
UserSelectionModel.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.element,
};
export default UserSelectionModel;
